import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.updateFormbuilderField
)

export const selectIsDeleteFormbuilderFieldModalOpen = createSelector(
    baseSelector,
    (state) => state.isDeleteFormbuilderFieldModalOpen
)

export const selectOnDelete = createSelector(
    baseSelector,
    (state) => state.onDelete
)